import { loc } from "../i18n/survey";

enum Focus {
  Nutrition = "Nutrition",
  Training = "Training",
  BuildingGoodHabits = "BuildingGoodHabits",
}

const focusQuestion = {
  name: "focus",
  title: loc("quiz.focus.title"),
  type: "radiogroup",
  choices: [
    {
      value: Focus.Nutrition,
      text: loc("quiz.focus.choices.nutrition"),
    },
    {
      value: Focus.Training,
      text: loc("quiz.focus.choices.training"),
    },
    {
      value: Focus.BuildingGoodHabits,
      text: loc("quiz.focus.choices.habits"),
    },
  ],
  isRequired: true,
  showOtherOption: true,
}

export {
  Focus,
  focusQuestion,
}